import { Directive, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { SettingsRequestStateBase } from './settings-request-state.base';

@Directive()
export abstract class CompanyScopedSettingsTabBase extends SettingsRequestStateBase implements OnChanges, OnDestroy
{
  @Input() public companyId: string | undefined;

  public ngOnChanges(changes: SimpleChanges): void
  {
    if (changes['companyId'] && !changes['companyId'].firstChange) {
      this.reloadSettings();
    }
  }

  protected abstract reloadSettings(): void;

  public ngOnDestroy(): void {
    this.disposeSettings();
  }
}
